module.exports = __webpack_public_path__ + "img/placeholder-video.40b6ee57.png";